import { Team } from '../models';
import { TeamRepository } from '../repositories';
import { ModerateContentUseCase } from './ModerateContentUseCase';

export class CreateTeamUseCase {
  constructor(
    private teamRepository: TeamRepository,
    private moderateContent: ModerateContentUseCase,
  ) {}

  async execute(params: {
    name: string;
    description?: string;
    logoUrl?: string;
    isPublic?: boolean;
    userId: string;
  }): Promise<Team> {
    const { name, description, logoUrl, isPublic, userId } = params;

    if (!name.trim()) {
      throw new Error('Team name is required');
    }

    await this.moderateContent.execute(name, 'team_name', userId);
    if (description) {
      await this.moderateContent.execute(description, 'team_description', userId);
    }

    const team = await this.teamRepository.create({
      name: name.trim(),
      description: description?.trim(),
      logoUrl,
      isPublic: isPublic ?? false,
      userId,
    });

    await this.teamRepository.addMember(team.id, userId);

    return team;
  }
}
